<iot-platform-ui-overview-card
  (cardButtonClicked)="onDispatchCardEvent($event)"
  [loading]="loading()"
  [overviewCard]="card()"
  class="oyan-site-overview-card m-4 flex-1"
/>
